export const COMMENCEMENT_STAGES = [
  "intake_received",
  "scoped",
  "invited",
  "brief_submitted",
  "spec_published",
  "agreement_signed",
  "infra_complete",
  "commenced",
] as const;

export type CommencementStage = (typeof COMMENCEMENT_STAGES)[number];

export const COMMENCEMENT_STAGE_LABELS: Record<CommencementStage, string> = {
  intake_received: "Enquiry received",
  scoped: "Scoped",
  invited: "Account invited",
  brief_submitted: "Brief submitted",
  spec_published: "Spec published",
  agreement_signed: "Agreement signed",
  infra_complete: "Infrastructure ready",
  commenced: "In development",
};

export const COMMENCEMENT_STAGE_ORDER: Record<CommencementStage, number> = {
  intake_received: 0,
  scoped: 1,
  invited: 2,
  brief_submitted: 3,
  spec_published: 4,
  agreement_signed: 5,
  infra_complete: 6,
  commenced: 7,
};

export function stageAtLeast(
  current: CommencementStage,
  minimum: CommencementStage,
): boolean {
  return COMMENCEMENT_STAGE_ORDER[current] >= COMMENCEMENT_STAGE_ORDER[minimum];
}

export function isCommencementStage(value: string): value is CommencementStage {
  return (COMMENCEMENT_STAGES as readonly string[]).includes(value);
}

export type CommencementNotifyStep =
  | "intake_accepted"
  | "scoped"
  | "invited"
  | "brief_submitted"
  | "spec_published"
  | "agreement_signed"
  | "infra_complete"
  | "packages_published"
  | "tech_setup_published"
  | "commenced";
